import React from 'react';

const ProgressBar = ({ progress }) => {
  return (
    <div className="mt-1.5">
      <div className="flex items-center justify-between text-xs text-muted-foreground mb-0.5">
        <span className="text-xs">Progress</span>
        <span className="text-xs font-semibold">{progress}%</span>
      </div>
      <div className="h-1.5 bg-muted rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;